import { useEffect } from 'react';

type UseKeyboardActionsProps = {
  enterAction?: () => void;
  escAction?: () => void;
  disable?: boolean;
  disableEnterAction?: boolean;
  disableEscAction?: boolean;
};
export const useKeyboardActions = ({
  enterAction,
  escAction,
  disable,
  disableEnterAction,
  disableEscAction,
}: UseKeyboardActionsProps) => {
  useEffect(() => {
    const listener = (event) => {
      if (!disableEnterAction && enterAction && (event.code === 'Enter' || event.code === 'NumpadEnter')) {
        event.preventDefault();
        enterAction();
      }
      if (!disableEscAction && escAction && event.code === 'Esc') {
        event.preventDefault();
        escAction();
      }
    };
    if (!disable) document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [disable]);

  return;
};
